const regexEmptyString = /^$/;

export { regexEmptyString };
